"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "bonusEditCtrl",
    function (
      $scope,
      $rootScope,
      $window,
      $filter,
      $stateParams,
      $localStorage,
      $state,
      BonusRequest,
      MessageService,
      Attachment,
      apiSettings,
      tools,
      attachment,
      model,
      types,
      deposits,
      subAreas,
      productLines,
      workflowApprovals,
      enumerators
    ) {
      var vm = this;
      vm.isNewRequest = false;
      vm.isEditingEnabled = false;
      vm.enableApproval = false;
      vm.attachments = attachment && attachment.length && attachment[0].attachments
        ? attachment[0].attachments
        : [];
      //Inicializações
      vm.model = model;
      vm.types = types;
      vm.deposits = deposits;

      vm.subAreas = subAreas;
      vm.enableSubAreaElement = true;

      vm.productLines = productLines;
      vm.userGroups = $localStorage.authorizationData.user.groups;
      vm.workflowApprovals = workflowApprovals;

      vm.enumerators = enumerators;

      vm.attachment = {}; // Inicializa a model que armazena as informações de um novo anexo
      vm.attachmentEditing = {}; // Inicializa a model que armazena as informações do anexo que está sendo editado
      vm.isAttaching = false;
      // CONFIGURAÇÃO DO UPLOAD
      vm.attachmentsInvoiceSale = [];
      vm.countAttachments = vm.attachments.length;

      vm.tempFolder = tools.getRandomString(8);
      vm.uploadConfig = {
        singleFile: true,
        testChunks: false,
        target:
          apiSettings.baseUri +
          "v1/internal/upload" +
          "?tempFolder=" +
          vm.tempFolder,
        headers: {
          Authorization: "Bearer " + $localStorage.authorizationData.token,
        },
      };
      vm.allowedFileExtensions = [];
      vm.maxAllowedFileSiz = 0;

      vm.initNewAttachment = function () {
        vm.attachment = {
          attachmentId: 0,
          attachmentTypeId: 10,
          isDeleted: false,
          isEditing: false,
          requiredDbUpdate: true,
        };
      };

      vm.deleteAttachment = function (item) {
        vm.countAttachments -= 1;
        item.isDeleted = true;
        item.requiredDbUpdate = true;
      };

      vm.showAttachmentForm = function (visible, enumAttachmentType) {
        vm.isAttaching = visible;
        vm.attachType = enumAttachmentType;
        vm.maxAllowedFileSize = 5242880;

        vm.initNewAttachment();

        // Reseta o formulário caso esteja fechando a modal de inclusão do anexo
        if (visible == false) vm.resetAttachmentForm();
      };

      vm.resetAttachmentForm = function () {
        var form = $scope.colorrequestAttachmentForm;
        form.$setPristine();
        form.$setUntouched();
      };

      vm.editAttachment = function (item) {
        vm.showAttachmentForm(true);

        vm.attachmentEditing = item; //Guarda a referência do item que está sendo editado numa variável global, para que a mesma seja atualizada no caso do usuário clicar no botão salvar
        angular.copy(vm.attachmentEditing, vm.attachment); //Atualiza a model de anexo com um cópia do objeto que está sendo editado
        vm.attachment.isEditing = true;
      };

      vm.saveAttachment = function (enumAttachmentType) {
        $rootScope.laddaLoading = true;

        vm.attachment.requiredDbUpdate = true;
        vm.attachment.promotionRequestId =
          vm.model.bonusesAndSponsorshipsRequestId;
        vm.attachment.userId = $localStorage.userId;

        // Verifica se é uma inclusão ou edição do objeto
        if (vm.attachment.isEditing == true) {
          angular.copy(vm.attachment, vm.attachmentEditing); // Repassa as atualizações feitas na model do anexo, para o objeto de referência (anexo que está sendo editado)
        } else {
          vm.attachments.push(vm.attachment); // Inclui o novo objeto no array
        }

        vm.showAttachmentForm(false, 0);
        $rootScope.laddaLoading = false;
      };

      vm.uploadSubmit = function ($files, $event, $flow) {
        if ($files[0] === undefined) return;

        // Valida o tamanho do arquivo
        if (
          tools.validateFileMaxSize($files[0].size, vm.maxAllowedFileSize) ==
          false
        )
          return;

        //change file name
        var splitFileName = $files[0].name.split(".");
        var name = formatDate(new Date()) + "_" + splitFileName[0];
        $files[0].name = name + "." + splitFileName[1];

        $flow.upload();
      };

      function formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear(),
          hour = "" + d.getHours(),
          minute = "" + d.getMinutes(),
          second = "" + d.getSeconds();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        if (hour.length < 2) hour = "0" + hour;
        if (minute.length < 2) minute = "0" + minute;
        if (second.length < 2) second = "0" + second;

        return [year, month, day].join("") + [hour, minute, second].join("");
      }

      vm.uploadSuccess = function ($file, $message, $flow) {
        var uploadResult = JSON.parse($message);
        vm.attachment.name = uploadResult.originalFilename;
        vm.attachment.fileDocument = uploadResult.filename;
        vm.attachment.url = tools.getFileTempPath(
          vm.tempFolder,
          uploadResult.filename
        );

        // Reseta o flow
        $flow.cancel();
      };

      vm.getallowedFileExtensions = function (enumAttachmentType) {
        return "." + vm.allowedFileExtensions.join(", .");
      };

      vm.getFileExtension = function (filename) {
        return tools.getFileExtension(filename);
      };

      vm.transformName = function (name) {
        if (name && name.length > 40) {
          return name.substr(0, 40) + "...";
        } else {
          return name || "";
        }
      };

      vm.getAttachs = function () {
        Attachment.list(
          {
            promotionRequestId: vm.model.bonusesAndSponsorshipsRequestId,
            moduleId: 3,
          },
          function (response) {
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      /*  angular.extend($scope.$parent.vm, {
        title: "Editar",
        insertUrl: null,
      }); */

      if (vm.model.bonusesAndSponsorshipsRequestDepositId) {
        for (var index = 0; index < vm.deposits.length; index++) {
          var element = vm.deposits[index];
          if (
            element.bonusesAndSponsorshipsRequestDepositId ===
            vm.model.bonusesAndSponsorshipsRequestDepositId
          ) {
            vm.selectedDeposit = element;
            break;
          }
        }
      }

      if (vm.model.bonusesAndSponsorshipsRequestTypeId) {
        for (var index = 0; index < vm.types.length; index++) {
          var element = vm.types[index];
          if (
            element.bonusesAndSponsorshipsRequestTypeId ===
            vm.model.bonusesAndSponsorshipsRequestTypeId
          ) {
            vm.selectedType = element;
            break;
          }
        }
      }

      if (vm.model.bonusesAndSponsorshipsRequestSubAreaId) {
        for (var index = 0; index < vm.subAreas.length; index++) {
          var element = vm.subAreas[index];
          if (
            element.bonusesAndSponsorshipsRequestSubAreaId ===
            vm.model.bonusesAndSponsorshipsRequestSubAreaId
          ) {
            vm.selectedSubArea = element;
            break;
          }
        }
      }

      if (vm.model.bonusesAndSponsorshipsRequestProductLineId) {
        for (var index = 0; index < vm.productLines.length; index++) {
          var element = vm.productLines[index];
          if (
            element.bonusesAndSponsorshipsRequestProductLineId ===
            vm.model.bonusesAndSponsorshipsRequestProductLineId
          ) {
            vm.selectedProductLine = element;
            break;
          }
        }
      }

      var $translate = $filter("translate");


      vm.isNewRequest = function () {
        return (
          vm.model.bonusesAndSponsorshipsRequestId === undefined ||
          vm.model.bonusesAndSponsorshipsRequestId == 0
        );
      };

      vm.isEditingRequest = function () {
        return (
          vm.model.bonusesAndSponsorshipsRequestId &&
          vm.model.bonusesAndSponsorshipsRequestId != 0
        );
      };

      //Habilitar aprovação conforme grupo do usuario
      vm.validateRequiredToApproval = function () {
        vm.userGroups.forEach((item) => {
          //Valida se esta no grupo de aprovador
          if (
            item.groupId == 1034 &&
            vm.model.status == "Aprovação Coordenador" &&
            vm.model.canApprove) {
            vm.enableApproval = true;
            vm.isEditingEnabled = false;
          }
          if (item.groupId == 1035 &&
            vm.model.status == "Aprovação Gerência" &&
            vm.model.canApprove) {
            vm.enableApproval = true;
            vm.isEditingEnabled = false;
          }
          if (
            item.groupId == 1036 &&
            vm.model.status == "Aprovação Diretoria" &&
            vm.model.canApprove) {
            vm.enableApproval = true;
            vm.isEditingEnabled = false;
          }
        });

        if (vm.enableApproval) {
          angular.extend($scope.$parent.vm, {
            title: "Aprovar solicitação",
            insertUrl: null,
          });
        }
      };

      // Aqui entra as regras de permissão para edição da request conforme o fluxo de aprovação
      vm.setEditingEnabled = function () {
        // Habilita os campos do formulário para edição ou novo cadastro.
        vm.isEditingEnabled = vm.isNewRequest() == true;

        if (
          vm.model.status == "Rejeitada" &&
          $localStorage.userId == vm.model.userId
        ) {
          vm.isEditingEnabled = true;
        }

        if (!vm.isCreatingNewRequest && vm.isEditingEnabled) {
          angular.extend($scope.$parent.vm, {
            title: "Editar Solicitação",
            insertUrl: null,
          });
        } else {
          angular.extend($scope.$parent.vm, {
            title: "Visualizar Solicitação",
            insertUrl: null,
          });
        }
      };

      //Valida se é um nova solicitação
      vm.setCreatingRequest = function () {
        vm.isCreatingNewRequest = vm.isNewRequest() == true;
        if (vm.isCreatingNewRequest) {
          angular.extend($scope.$parent.vm, {
            title: "Criar Solicitação",
            insertUrl: null,
          });
        }
      };

      //Auto completo do cliente (Conta de Bonificação e patrocínio sem acesso ao endpoint)
      vm.getCustomers = function (val) {
        return BonusRequest.customerList({
          keyword: val,
        }).$promise;
      };

      vm.validateComment = function (msg) {
        // Verifica se o comentário foi preenchido
        if (vm.model.comment == undefined || vm.model.comment == "") {
          MessageService.alertInfo(msg);
          return false;
        }
      };

      vm.save = function () {
        //zera value 2 se tipo do pagamento não for id 1
        if (vm.selectedType.bonusesAndSponsorshipsRequestTypeId == 1) {
          var value2 = vm.model.value2;
        } else {
          var value2 = 0;
        }

        // Valida se está editando um campo e adiciona id do request de forma condicional
        if (vm.isEditingRequest() == true) {
          var bonusesAndSponsorshipsRequestId =
            vm.model.bonusesAndSponsorshipsRequestId;
        } else {
          var bonusesAndSponsorshipsRequestId = null;
        }

        // Valida se está criando novo request e altera o customerId de forma condicional
        if (vm.isCreatingNewRequest) {
          var customer = vm.model.customerName.customerId;
        } else {
          var customer = vm.model.customerId;
        }

        var params = {
          bonusesAndSponsorshipsRequestId: bonusesAndSponsorshipsRequestId,
          userId: $localStorage.userId,
          customerId: customer,
          value1: vm.model.value1,
          value2: value2,
          startsOn: vm.model.startsOn,
          bonusesAndSponsorshipsRequestTypeId:
            vm.selectedType.bonusesAndSponsorshipsRequestTypeId,
          bonusesAndSponsorshipsRequestDepositId:
            vm.selectedDeposit.bonusesAndSponsorshipsRequestDepositId,
          bonusesAndSponsorshipsRequestSubAreaId:
            vm.selectedSubArea.bonusesAndSponsorshipsRequestSubAreaId,
          bonusesAndSponsorshipsRequestProductLineId:
            vm.selectedProductLine.bonusesAndSponsorshipsRequestProductLineId,
          description: vm.model.description,
          workflowApprovalNext: {
            enumStatusApproval: "Aprovado",
            userId: $localStorage.userId,
          },
          attachmentsTypes: [
            {
              attachmentTypeId: 10,
              name: "Documentos Complementares",
              order: 1,
              enumType: 10,
              permissionToEdit: true,
              attachments: vm.attachments,
            },
          ],
          tempFolder: vm.tempFolder,
        };

        if (vm.isCreatingNewRequest) {
          BonusRequest.insert(
            params,
            function (response) {
              $state.go("main.bonusesandsponsorship");
            },
            function (error) {
              MessageService.alertError(error.data);
            }
          );
        } else if (vm.isEditingRequest()) {
          BonusRequest.update(
            params,
            function (response) {
              $state.go("main.bonusesandsponsorship");
            },
            function (response) {
              MessageService.alertError(response.data);
            }
          );
        } else {
          MessageService.alertError("Erro ao editar ou cadastrar solicitação");
        }
      };

      vm.approve = function () {
        MessageService.confirm(
          function () {
            vm.doApproval("Aprovado");
          },
          "Confirmação",
          "Deseja realmente aprovar solicitação ?"
        );
      };

      vm.disapprove = function () {
        // Verifica se o comentário foi preenchido
        if (
          vm.validateComment(
            "Para prosseguir com a reprovação, é necessário preencher o motivo no campo de comentário."
          ) == false
        )
          return;

        MessageService.confirm(
          function () {
            vm.doApproval("Reprovado");
          },
          "Confirmação",
          "Deseja realmente reprovar essa solicitação?"
        );
      };

      vm.cancel = function () {
        // Verifica se o comentário foi preenchido
        if (
          vm.validateComment(
            "Para prosseguir com o cancelamento, é necessário preencher o motivo no campo de comentário."
          ) == false
        )
          return;

        MessageService.confirm(
          function () {
            vm.doCancel("Cancelado");
          },
          "Confirmação",
          "Deseja realmente cancelar essa solicitação?"
        );
      };

      vm.getWorkflowApprovalParameter = function (enumStatusApproval) {
        return {
          bonusesAndSponsorshipsRequestId:
            vm.model.bonusesAndSponsorshipsRequestId,
          enumStatusApproval: enumStatusApproval,
          comment: vm.model.comment,
        };
      };

      vm.doApproval = function (enumStatusApproval) {
        $rootScope.laddaLoading = true;

        var params = vm.getWorkflowApprovalParameter(enumStatusApproval);

        BonusRequest.workFlowApproval(
          params,
          function () {
            $state.go("main.bonusesandsponsorship");
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.doCancel = function (enumStatusApproval) {
        $rootScope.laddaLoading = true;

        var params = vm.getWorkflowApprovalParameter(enumStatusApproval);

        BonusRequest.workFlowApproval(
          params,
          function () {
            $state.go("main.bonusesandsponsorship");
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      /*  angular.extend($scope.$parent.vm, {
        title: "Criar solicitação",
        insertUrl: null,
      }); */

      vm.setEditingEnabled();
      vm.setCreatingRequest();
      vm.validateRequiredToApproval();
      /* vm.getAttachs(); */
      $rootScope.laddaLoading = false;

      if (vm.isEditingEnabled && vm.subAreas.length == 1) {
        vm.selectedSubArea = vm.subAreas[0];
        vm.enableSubAreaElement = false;
      }
    }
  );
